<template>
  <div>
    <PageAllow controller="Shops" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="shopKeyword"
                @text="shopKeywordText($event)"
                :label="
                  $t('AnnouncementShop.shopsKeyword', [$consts.shopName()])
                "
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                small
                color="success"
                dark
                @click.stop="submit()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fas fa-save</v-icon>
                {{ $t("AnnouncementShop.submit") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="login_user_id"
                    v-model="loginUserId"
                    @text="loginUserIdText($event)"
                    :label="$t('AnnouncementShop.shopUserKeyword')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrict v-model="districtSelected" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="shopsItems"
            :loading="loading"
            multi-sort
            class="elevation-2 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.choose>
              <v-checkbox
                class="mt-2 mb-n3"
                color="primary"
                :indeterminate="
                  shopsItems.find((detail) => detail.choose != chooseAll)
                    ? true
                    : false
                "
                v-model="chooseAll"
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{ $t("CRUD.chooseAll") }}
                  </span>
                </template>
              </v-checkbox>
            </template>

            <template v-slot:item.choose="{ item }">
              <div class="d-flex mt-n2 mb-n3">
                <v-checkbox
                  color="primary"
                  v-model="item.choose"
                  :true-value="1"
                  :false-value="0"
                  :disabled="item.disabled"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                    </span>
                  </template>
                </v-checkbox>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Announcement from "@/api/announcement";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import ShopStockTakePlans from "@/api/shop_stock_take_plans";

const defaultOptions = {
  keyword: "",
  login_user_id: "",
  status: [1],
  district_id: "",
  psi_expire_flg: 1,//门店开启库存管理且在有效期内
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherDistrict,
  },

  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
    shopsKeyword: "",
    shops: [],
    showSelected: [],
    chooseAll: 0,
    shopKeyword: "",
    loginUserId: "",
    push_shop_ids: [],
    push_shops: [],
    districtSelected: null,
    districtSelectedIds: [],
  }),

  computed: {
    shopsItems() {
      return this.abc();
    },
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stockTakeOrders"),
          disabled: false,
          href: "/stock-take-orders",
        },
        {
          text: i18n.t("shopStockTakePlans.objectName"),
          disabled: false,
          href: "/stock-take-orders/detail/stock-take-plans/shop-stock-take-plans",
        },
        {
          text: i18n.t("shopStockTakePlans.push_to_shop", [
            this.$consts.shopName(),
          ]),
          disabled: true,
          href: "",
        },
      ];
    },
    headers() {
      return [
        {
          text: i18n.t("AnnouncementShop.Fields.shop_code"),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("AnnouncementShop.Fields.shop_name"),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("AnnouncementShop.Fields.district"),
          align: "start",
          sortable: false,
          value: "district.name",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },
    ...mapState(["loading", "settings"]),
  },
  mounted() {
    ShopStockTakePlans.fetchOne(this.$route.params.id).then(
      function (response) {
        if (response.data.status.isOK()) {
          response.data.shop_stock_take_plan.shop_stock_take_plan_details.forEach(
            (detail) => {
              this.push_shop_ids.push(detail.shop.id);
              this.push_shops.push(detail.shop);
            }
          );
        }
      }.bind(this)
    );
    this.getShopsFromAPI();
  },
  methods: {
    resetSearch() {
      this.districtSelected = null;
      [this.$refs.keyword, this.$refs.login_user_id].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.abc();
    },

    abc() {
      return this.shops.filter(
        (e) =>
          ((this.districtSelected &&
            this.districtSelectedIds.find((detail) => {
              return detail == e.district.id;
            })) ||
            !this.districtSelected) &&
          ((this.shopKeyword && e.shop_name.indexOf(this.shopKeyword) > -1) ||
            e.shop_code.indexOf(this.shopKeyword) > -1 ||
            !this.shopKeyword) &&
          ((this.loginUserId &&
            (e.shop_user ? e.shop_user.login_user_id : "").indexOf(
              this.loginUserId
            ) > -1) ||
            (e.shop_user ? e.shop_user.name : "").indexOf(this.loginUserId) >
              -1 ||
            !this.loginUserId)
      );
    },
    shopKeywordText(e) {
      this.shopKeyword = e;
    },
    loginUserIdText(e) {
      this.loginUserId = e;
    },

    getShopsFromAPI() {
      Announcement.fetchAllForSelect(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            var shops = response.data.shops;
            shops.forEach((detail) => {
              detail.choose = 0;
            });
            this.shops = shops;
            this.shops.map((v) => {
              if (this.push_shop_ids.includes(v.id)) {
                v.choose = 1;
              }
              return v;
            });
          }
        }.bind(this)
      );
    },

    submit() {
      let shop_ids = this.shops.filter((v) => !!v.choose).map((v) => v.id);
      var data = [];
      data.push({
        id: this.$route.params.id,
        shop_ids: shop_ids,
      });
      ShopStockTakePlans.settingShop(data[0]).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push(
              "/stock-take-orders/detail/stock-take-plans/shop-stock-take-plans"
            );
          }
        }.bind(this)
      );
    },
    // 查询分组
    getdistrictSelectedIds(item, ids = []) {
      item.forEach((e) => {
        ids.push(e.id);
        if (e.districts && e.districts.length > 0) {
          this.getdistrictSelectedIds(e.districts, ids);
        }
      });
      return ids;
    },
  },

  watch: {
    shops: {
      deep: true,
      handler() {},
    },
    push_shop_ids: {
      deep: true,
      handler() {
        this.shops.map((v) => {
          if (this.push_shop_ids.includes(v.id)) {
            v.choose = 1;
          }
          return v;
        });
      },
    },

    chooseAll: {
      handler() {
        this.shopsItems.forEach(
          function (e) {
            e.choose = this.chooseAll ? 1 : 0;
          }.bind(this)
        );
      },
    },
    districtSelected: {
      handler() {
        var arr = [];
        arr.push(this.districtSelected);
        if (this.districtSelected) {
          this.districtSelectedIds = this.getdistrictSelectedIds(arr);
        }
      },
    },
  },
};
</script>

<style>
</style>